/* eslint-disable camelcase, react/jsx-pascal-case */
import SelectBox_ListPreviewFlat from './selectBox_ListPreviewFlat';

export default SelectBox_ListPreviewFlat;
